// Open/close for the EG mobile nav drawer.
const init = () => {
  const dialog = document.getElementById('eg-header-drawer');
  if (!dialog) return;
  document.querySelectorAll('[data-eg-drawer-open]').forEach((btn) =>
    btn.addEventListener('click', () => dialog.showModal())
  );
  dialog.querySelectorAll('[data-eg-drawer-close]').forEach((btn) =>
    btn.addEventListener('click', () => dialog.close())
  );
  dialog.addEventListener('click', (e) => {
    if (e.target === dialog) dialog.close(); // backdrop click
  });
};
document.readyState === 'loading'
  ? document.addEventListener('DOMContentLoaded', init)
  : init();
